<template>
    <div class="about-page">
        <aboutMain></aboutMain>
        <aboutBcn></aboutBcn>
        <aboutCodex></aboutCodex>
        <aboutSocial></aboutSocial>
        <aboutCertificate></aboutCertificate>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import aboutMain from '@/components/about-page/about-main.vue'
    import aboutBcn from '@/components/about-page/about-bcn.vue'
    import aboutCodex from '@/components/about-page/about-codex.vue'
    import aboutSocial from '@/components/about-page/about-social.vue'
    import aboutCertificate from '@/components/about-page/about-certificate.vue'
    export default {
        name: 'about--page',
        components: {
            aboutMain,
            aboutBcn,
            aboutCodex,
            aboutSocial,
            aboutCertificate,
        },
        data () {
            return {
                // titlePage: 'О компании',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.aboutPage != null) {
                next(vm => {
                  vm.$store.commit('removePageLoaderImg');
                  setTimeout(() => {
                    vm.$parent.$refs.topProgress.done()
                  }, 300);
                });
            } else {
                store.dispatch('getAboutPageData').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                            vm.$store.commit('removePageLoaderImg');
                            setTimeout(() => {
                                vm.$parent.$refs.topProgress.done()
                            }, 300);
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'about';
        },
        created () {
            // document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-page.scss';
    @import '@/styles/components/about-page/respond/about-page-respond.scss';
    // @import '@/styles/respond/about/about-respond.scss';
</style>